import request from '@/utils/request';

export const logout = () => request.post('/manager-api/user/logout', {});

export const modifyPassword = params =>
  request.post('/manager-api/user/changePassword', params);
export const getVerifyCode = params =>
  request.get('/pipe-api/auth/formula', { params });
